
<div class="row d-flex justify-content-end">
  <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/porfilo_buckets']" routerLinkActive="router-link-active" >Back</a>
</div>

<div style="margin-right: 32px;">
<div>
    <h4 class="title" style="margin-top: 15px;">Portfolio List</h4>
    <!-- <button (click)="Change_list('portfolio')">
      Portfolio List
    </button>
    <button (click)="Change_list('fint_dup')">
      Duplication Fint Id
    </button>
    <button (click)="Change_list('acc_dup')">
      Duplication Passort & ACC
    </button> -->
</div>
</div>

<div class="card" style="padding: 10px; border-radius:10px;">





<div style="margin-left: 20px;padding-bottom: 15px;">

<div class="row">
  <div class="row">
    <div class="col-12">
      <div  class="col-md-8">
        <label>filter Date</label>
    <input type="date" class="form-control"  [(ngModel)]="ptp_start_date">
    </div>
    <div  class="col-md-6">
      <label>Action</label><br>
      <button class="btn btn-sm btn-dark mb-4" (click)="filterdateFollowip()">
          Search
      </button>
      <button style="margin-left: 10px; " class="btn btn-sm btn-dark mb-4" (click)="clear()">
        Clear
    </button>
  </div>

    </div>


</div>

    <div class="col-md-12">
        <div>


       <!-- <div class="animate" *ngIf="!loading">

       </div> -->
        <!-- <div *ngIf="loading" > -->


          <div class="row" style="margin-bottom: 50px;">
            <!-- <div class="col-md-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Account Search" />
              </span>
            </div>
            <div class="col-md-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Full Search" />
              </span>
            </div> -->
            <!-- <div class="col-md-6 text-right">
              <button class="btn btn-primary" style="margin-right: 10px;">Personal Loan</button>

              <button class="btn btn-primary" style="margin-right: 10px;">Auto Loan</button>

              <button class="btn btn-primary" style="margin-right: 10px;">Credit Cards</button>

              <button class="btn btn-primary" style="margin-right: 0px;">Sales Finance</button>
            </div> -->
          </div>
          <div class="doc-table">

            <div class="card-box">
               <p-table [value]="Data | filterBy:userFilter" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="10"
               [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
               [globalFilterFields]="['type']">

              <ng-template pTemplate="header">

                <tr style="text-align: center;" class="thhead">
                  <th style="width: 50px;">S.No</th>
                  <th>Bank</th>
                  <th>Agent</th>
                  <th>Customer Name</th>
                  <th>Passport No</th>
                  <th>CID</th>
                  <th>Acc Number</th>
                  <th>PTP AMOUNT</th>
                  <th>FOLLOWUP DATE</th>
                  <th>Logged Date And Time</th>
                  <th>Main Status</th>
                  <th>Sub Status</th>
                  <th>Primary Status</th>
                  <th style="width: 100px;">Action</th>
                </tr>
                  <tr>
                    <th></th>
                    <th> <input class="form-control" type="text" (change)="getname($event)"> </th>
                    <th> <input class="form-control" type="text" (change)="getFin($event)"> </th>
                    <th> <input class="form-control" type="text" (change)="getPass($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getAcc($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getAgg($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getCif($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getOTS($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getnat($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getcycle($event)"></th>
                    <th> <input class="form-control" type="text" (change)="getflow($event)"></th>

                    <th></th>
                    <th></th>
                    <th></th>
                </tr>

              </ng-template>
              <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow" (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">
                  <td style="text-align: center;">{{i+1}}</td>
                  <!-- <td><a (click)="showPositionDialog()" style="color: #0e69dd;">1.26472587459</a></td> -->
                  <td style="text-align: center;">{{item?.Bank_Name}}</td>
                  <td style="text-align: center;">{{item?.agentName}}</td>
                  <td style="text-align: center;">{{item?.Customer_Name}}</td>
                  <td style="text-align: center;">{{item?.passport_no}}</td>
                  <td style="text-align: center;">{{item?.cif}}</td>
                  <td style="text-align: center;">{{item?.acc_no}}</td>
                  <td style="text-align: center;">{{item?.ptp_amount}}</td>
                  <td style="text-align: center;">{{item?.fdate |date:'yyyy-MM-dd '}}</td>
                  <td style="text-align: center;">{{item?.log_date |date:'yyyy-MM-dd '}}</td>
                  <td style="text-align: center;">{{item?.mstatus}}</td>
                  <td style="text-align: center;">{{item?.substatus}}</td>
                  <td style="text-align: center;">{{item?.primary_status}}</td>



                  <!-- <td>
                          User
                      </td>
                      <td>
                          Admin
                      </td>
                      <td>
                          16-09-2020
                      </td>
                      <td>
                          17-09-2020
                      </td> -->
                  <td class="act">
                    <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true"
                    pTooltip="View More Details" (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)"></i>

                  </td>
                </tr>
              </ng-template>
             </p-table>  </div>

          </div>
    </div>
        </div>
      </div>
    </div>

</div>



